import { useState } from 'react';
import { Input, Empty, Tag } from 'antd';
import { PlusOutlined, FolderOutlined, MessageOutlined, FileTextOutlined, SettingOutlined, SearchOutlined } from '@ant-design/icons';

const mockProjects = [
  { id: 1, name: 'Simon\'s Cat 品牌升级', updatedAt: '2026/07/28 14:32', conversations: 8, assets: 23 },
  { id: 2, name: '咖啡节海报设计', updatedAt: '2026/07/20 09:15', conversations: 3, assets: 12 },
  { id: 3, name: '端午亲子游活动策划', updatedAt: '2026/07/15 16:45', conversations: 12, assets: 45 },
  { id: 4, name: '新品Listing优化方案', updatedAt: '2026/07/10 11:20', conversations: 5, assets: 8 },
  { id: 5, name: 'TikTok种草视频脚本', updatedAt: '2026/07/05 08:30', conversations: 15, assets: 67 },
];

const ProjectsPage = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const filtered = mockProjects.filter((p) =>
    p.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div style={{ maxWidth: 1280, margin: '0 auto', padding: '32px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 32 }}>
        <div>
          <h1 style={{ fontSize: 28, fontWeight: 700, color: '#fff', marginBottom: 4 }}>项目中心</h1>
          <p style={{ color: 'var(--text-secondary)', fontSize: 14 }}>管理你的所有品牌增长项目 · 共 {mockProjects.length} 个项目</p>
        </div>
        <button className="btn-gradient" style={{ height: 40, padding: '0 20px', fontSize: 14 }}>
          <PlusOutlined /> 新增项目
        </button>
      </div>

      <div style={{ marginBottom: 24 }}>
        <Input
          className="input-dark"
          placeholder="搜索项目名称..."
          prefix={<SearchOutlined style={{ color: 'var(--text-tertiary)' }} />}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          style={{ maxWidth: 400, height: 42 }}
        />
      </div>

      {filtered.length > 0 ? (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 24 }}>
          <div className="glass-card hover-lift" style={{ minHeight: 200, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 12, cursor: 'pointer', border: '2px dashed rgba(255,255,255,0.08)', background: 'transparent' }}>
            <div style={{ width: 52, height: 52, borderRadius: '50%', background: 'var(--gradient-brand)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22, color: '#fff', boxShadow: '0 8px 24px rgba(102,126,234,0.3)' }}><PlusOutlined /></div>
            <span style={{ color: 'var(--text-secondary)', fontSize: 14 }}>新增项目</span>
          </div>

          {filtered.map((proj) => (
            <div key={proj.id} className="glass-card hover-lift" style={{ cursor: 'pointer', padding: 24 }} onClick={() => { window.location.href = `/projects/${proj.id}`; }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20 }}>
                <div style={{ width: 44, height: 44, borderRadius: 12, background: 'var(--gradient-brand)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18, color: '#fff' }}><FolderOutlined /></div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ color: '#fff', fontWeight: 600, fontSize: 16, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{proj.name}</div>
                  <div style={{ color: 'var(--text-tertiary)', fontSize: 12 }}>更新于 {proj.updatedAt}</div>
                </div>
              </div>
              <div style={{ display: 'flex', gap: 16, marginBottom: 16 }}>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ color: '#fff', fontSize: 18, fontWeight: 600 }}>{proj.conversations}</div>
                  <div style={{ color: 'var(--text-tertiary)', fontSize: 11 }}>对话</div>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ color: '#fff', fontSize: 18, fontWeight: 600 }}>{proj.assets}</div>
                  <div style={{ color: 'var(--text-tertiary)', fontSize: 11 }}>资产</div>
                </div>
              </div>
              <div style={{ display: 'flex', gap: 8 }}>
                {[
                  { label: '对话', icon: <MessageOutlined /> },
                  { label: '资产', icon: <FileTextOutlined /> },
                ].map((btn) => (
                  <button key={btn.label} style={{ flex: 1, padding: '7px 0', borderRadius: 8, background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.06)', color: 'var(--text-secondary)', fontSize: 13, cursor: 'pointer' }} onClick={(e) => e.stopPropagation()}>
                    {btn.icon}{btn.label}
                  </button>
                ))}
                <button style={{ width: 36, borderRadius: 8, background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.06)', color: 'var(--text-secondary)', cursor: 'pointer' }} onClick={(e) => e.stopPropagation()}><SettingOutlined /></button>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <Empty description={<span style={{ color: 'var(--text-tertiary)' }}>{searchQuery ? '没有找到匹配的项目' : '还没有项目'}</span>} style={{ padding: '80px 0' }} />
      )}
    </div>
  );
};

export default ProjectsPage;
